var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { clone, Handler } from "./Handler";
import { canSend, getRecvRtpCapabilities, validateRtpCapabilities, validateSctpCapabilities } from "./Ortc";
import { Transport } from "./Transport";
const DEBUG_LOG_CAPABILITIES = false;
export class Device {
    constructor() {
        this.loaded = false;
        this.canProduceByKind = {
            audio: false,
            video: false
        };
    }
    load(routerRtpCapabilities) {
        return __awaiter(this, void 0, void 0, function* () {
            routerRtpCapabilities = clone(routerRtpCapabilities, undefined);
            let handler;
            try {
                if (this.loaded)
                    throw new Error("already loaded");
                validateRtpCapabilities(routerRtpCapabilities);
                handler = new Handler();
                const nativeRtpCapabilities = yield handler.getNativeRtpCapabilities();
                if (DEBUG_LOG_CAPABILITIES)
                    console.log("[multiplayer] load() | got native RTP capabilities:%o", nativeRtpCapabilities);
                validateRtpCapabilities(nativeRtpCapabilities);
                this.extendedRtpCapabilities = nativeRtpCapabilities;
                if (DEBUG_LOG_CAPABILITIES)
                    console.log("[multiplayer] load() | got extended RTP capabilities:%o", this.extendedRtpCapabilities);
                this.canProduceByKind.audio = canSend("audio", this.extendedRtpCapabilities);
                this.canProduceByKind.video = canSend("video", this.extendedRtpCapabilities);
                this.recvRtpCapabilities = getRecvRtpCapabilities(this.extendedRtpCapabilities);
                validateRtpCapabilities(this.recvRtpCapabilities);
                if (DEBUG_LOG_CAPABILITIES)
                    console.log("[multiplayer] load() | got receiving RTP capabilities:%o", this.recvRtpCapabilities);
                this._sctpCapabilities = yield handler.getNativeSctpCapabilities();
                if (DEBUG_LOG_CAPABILITIES)
                    console.log("[multiplayer] load() | got native SCTP capabilities:%o", this._sctpCapabilities);
                validateSctpCapabilities(this._sctpCapabilities);
                this.loaded = true;
                handler.close();
            }
            catch (error) {
                if (handler !== undefined) {
                    handler.close();
                }
                console.error("[multiplayer]", error);
            }
        });
    }
    createSendTransport(remoteClientId, { id, iceParameters, iceCandidates, dtlsParameters, sctpParameters, iceServers, iceTransportPolicy, additionalSettings, proprietaryConstraints }) {
        return this.createTransport(remoteClientId, {
            direction: "send",
            id: id,
            iceParameters: iceParameters,
            iceCandidates: iceCandidates,
            dtlsParameters: dtlsParameters,
            sctpParameters: sctpParameters,
            iceServers: iceServers,
            iceTransportPolicy: iceTransportPolicy,
            additionalSettings: additionalSettings,
            proprietaryConstraints: proprietaryConstraints
        });
    }
    createRecvTransport(remoteClientId, { id, iceParameters, iceCandidates, dtlsParameters, sctpParameters, iceServers, iceTransportPolicy, additionalSettings, proprietaryConstraints }) {
        return this.createTransport(remoteClientId, {
            direction: "recv",
            id: id,
            iceParameters: iceParameters,
            iceCandidates: iceCandidates,
            dtlsParameters: dtlsParameters,
            sctpParameters: sctpParameters,
            iceServers: iceServers,
            iceTransportPolicy: iceTransportPolicy,
            additionalSettings: additionalSettings,
            proprietaryConstraints: proprietaryConstraints
        });
    }
    createTransport(remoteClientId, { direction, id, iceParameters, iceCandidates, dtlsParameters, sctpParameters, iceServers, iceTransportPolicy, additionalSettings, proprietaryConstraints }) {
        if (!this.loaded)
            throw new Error("not loaded");
        else if (typeof id !== "string")
            throw new TypeError("missing id");
        return new Transport(remoteClientId, {
            direction,
            id,
            iceParameters,
            iceCandidates,
            dtlsParameters,
            sctpParameters,
            iceServers,
            iceTransportPolicy,
            additionalSettings,
            proprietaryConstraints,
            extendedRtpCapabilities: this.extendedRtpCapabilities,
            canProduceByKind: this.canProduceByKind
        });
    }
}
